// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b57942f","885":"4ce26d14"}[chunkId] + ".chunk.js";
};